import React from 'react'
import BigTag from './big_tag'

const BigTagList = ({ bigTags, editTag, newTimeEntry, newTimer, toggleTagReport, onSelect }) => {
    return (
        <div className="big-tag-list">
            <div className="big-tag-all">
                {bigTags.map((bt, i) => {
                    return (
                        <BigTag
                            key={i}
                            bigTag={bt}
                            editTag={editTag}
                            newTimeEntry={newTimeEntry}
                            newTimer={newTimer}
                            toggleTagReport={toggleTagReport}
                            onSelect={onSelect}
                            showMenu={true}
                            showInfo={true}
                        />
                    )
                })}
            </div>
        </div>
    )
}

export default BigTagList


// WEBPACK FOOTER //
// ./src/components/big_tag_list.jsx